import { MainLayout } from '@/modules/Activation/components/MainLayout'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import { getCache } from '@/utils/cache'
import useWindowSize from '@/utils/useWindowSize'
import { Loader } from '@conexasaude/conexa-hero'
import { Fragment, FunctionComponent, useMemo } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { STEPS_ROUTES } from '../../constants'
import { getComponents } from '../../utils/getComponents'
import {
  EVENT_NAME_COMPLEMENT,
  ROUTES_WITHOUT_FOOTER_SPACING,
} from './constants'
import { usePatientAccountStore } from '@/modules/Auth/store/PatientAccount.store'
import {
  useGetClinicColorsById,
  useGetClinicColorsByUniqueCode,
} from '@/theme/queries'

const Signup: FunctionComponent = () => {
  const { page, idClinic } = useParams<{ page: string; idClinic: string }>()
  const { isMobile } = useWindowSize()
  const { theme } = useThemeGeneratorContext()
  const { account } = usePatientAccountStore()

  const searchParamsInstance = useMemo(() => {
    return new URLSearchParams(location.search)
  }, [])

  const searchParams = useMemo(() => {
    return {
      uniqueCode: searchParamsInstance.get('uniqueCode'),
      clinicId: searchParamsInstance.get('clinicId'),
    }
  }, [searchParamsInstance])

  const uniqueCodeCached = getCache<string>('unique-code')

  const getClinicColorsByUniqueCodeQuery = useGetClinicColorsByUniqueCode(
    searchParams.uniqueCode || uniqueCodeCached,
  )

  const getClinicColorsByIdQuery = useGetClinicColorsById(
    Number(idClinic) || Number(searchParams?.clinicId),
  )

  const clinicUniqueCode = useMemo(
    () => theme?.codigoUnicoClinica,
    [theme?.codigoUnicoClinica],
  )

  const isLoadingTheme = useMemo(() => {
    return (
      getClinicColorsByUniqueCodeQuery.isFetching ||
      getClinicColorsByIdQuery.isFetching
    )
  }, [
    getClinicColorsByIdQuery.isFetching,
    getClinicColorsByUniqueCodeQuery.isFetching,
  ])

  const isValidPage = Object?.values(STEPS_ROUTES)?.includes(page)

  if (!isValidPage) return <Redirect to={STEPS_ROUTES.CPF} />
  if (isLoadingTheme) return <Loader />

  return (
    <MainLayout
      tagEventName={
        `at_patient_signup${EVENT_NAME_COMPLEMENT[page]}` || 'at_patient_signup'
      }
      additionalFooterSpacing={
        !ROUTES_WITHOUT_FOOTER_SPACING.includes(page) && !isMobile
      }
      uniqueCode={clinicUniqueCode}
      showLogo={!account?.idAccount}
      showRegisterPsychologistButton={page === 'cpf'}
    >
      <Fragment>{getComponents(page)}</Fragment>
    </MainLayout>
  )
}

export default Signup
